import config from 'config/app.config';

/**
 * Send API request to backend
 * @param {string} endpoint 
 * @param {object} body 
 */
export default function apiHelper(endpoint, body = {}) {
	let url = config.apiURL + endpoint;
	var myHeaders = new Headers();
	myHeaders.append('Content-Type', 'application/json');

	let fetchConfig = {
		method: 'POST',
		mode: 'cors',
		headers: myHeaders,
		cache: 'default',
		body: JSON.stringify({...body, env: config.env})
	};

	let promise = new Promise((resolve, reject)=>{
		fetch(url, fetchConfig).then(
			(response)=>{
				response.json().then(
					(data) => {
						if (data.status === 'success') {
							resolve(data);
						} else {
							reject(data);
						}
					},
					(rejection) => {
						console.error('api rejection:' + rejection);
						console.error(response);
						reject('fetch-error');
					}
				);
			},
			(error)=>{
				reject(error);
			}
		);
	});

	return promise;	
}
